import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import PropTypes from 'prop-types'
import { trackEvent, trackFbEvent } from '~scripts/helpers'

const handleTracking = (href, track, fbTrack) => {
  const type = getLinkType(href)
  track && trackEvent(track.category, track.action, track.label)
  fbTrack && trackFbEvent(fbTrack.name)

  if (type === 'external') {
    trackOutbound(href)
  }
}

const trackOutbound = (href) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'Click', {
      event_category: 'interest-OutboundLink',
      event_label: href,
      transport_type: 'beacon',
      non_interaction: true
    })
  }
}

const getLinkType = (href) => {
  const isInternal = /^\/(?!\/)/.test(href)
  const isMailto = /^(tel:|mailto:)/g.test(href)

  if (isMailto) {
    return 'mailto'
  }

  if (isInternal) {
    return 'internal'
  }

  return 'external'
}

const Link = ({ children, href, text, className, onClickEvent, track, fbTrack, ...other }) => {
  const type = getLinkType(href)

  if (type === 'mailto') {
    return (
      <a
        {...other}
        href={href}
        className={className}
        onClick={() => {
          handleTracking(href, track, fbTrack)
          onClickEvent && onClickEvent()
        }}
      >
        {text}
        {children}
      </a>
    )
  }

  if (type === 'internal') {
    return (
      <GatsbyLink
        {...other}
        to={href}
        className={className}
        onClick={() => {
          handleTracking(href, track, fbTrack)
          onClickEvent && onClickEvent()
        }}
      >
        {text}
        {children}
      </GatsbyLink>
    )
  }

  return (
    <a
      {...other}
      href={href}
      className={className}
      target="_blank" rel="noreferrer noopener"
      onClick={() => {
        handleTracking(href, track, fbTrack)
        onClickEvent && onClickEvent()
      }}
    >
      {text}
      {children}
    </a>
  )
}

Link.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string,
  track: PropTypes.shape({
    category: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }),
  fbTrack: PropTypes.shape({
    name: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired
  }),
  onClickEvent: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default Link
